import { PUSH_APP_NAME, PUSH_PLATFORM } from "@/configs/common"

import authorizedRequest from "@/lib/axios/authorizedRequest"

export interface RegisterDeviceParams {
  device_token: string
  app_name?: string
  app_version?: string
  platform?: string
}

export interface DeviceResponse {
  id: string
  user_id: string
  device_token: string
  app_name: string
  app_version: string
  platform: string
  last_login_at: string
  created_at: string
}

export async function getDevices(): Promise<{
  status: boolean
  data: DeviceResponse[]
}> {
  return authorizedRequest.get("/v1/devices") as Promise<{
    status: boolean
    data: DeviceResponse[]
  }>
}

/**
 * Register a device token for the authenticated user (push notifications).
 * Returns 422 if this device_token is already registered for this user.
 */
export async function registerDevice(
  params: RegisterDeviceParams
): Promise<{ status: boolean; data: DeviceResponse }> {
  const body = {
    device_token: params.device_token,
    app_name: params.app_name ?? PUSH_APP_NAME,
    app_version: params.app_version ?? "latest",
    platform: params.platform ?? PUSH_PLATFORM,
  }
  return authorizedRequest.post("/v1/devices", body) as Promise<{
    status: boolean
    data: DeviceResponse
  }>
}

/**
 * Unregister a device (remove from push targeting). Silent: no toast.
 */
export async function unregisterDevice(
  deviceId: string
): Promise<{ status: boolean; data: null }> {
  return authorizedRequest.delete(`/v1/devices/${deviceId}`) as Promise<{
    status: boolean
    data: null
  }>
}
